export enum LoginFormState {
    FillIn, Login
}
